import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { summarizeResponse } from '@graphql/helpers';

import { SummaryResponseMessage } from '@domains/new-conversation/molecules/SummaryResponseMessage/SummaryResponseMessage';
import { SummaryUserResponseMessage } from '@domains/new-conversation/molecules/SummaryUserResponseMessage/SummaryUserResponseMessage';
import {
    SummaryTitle,
    SummaryWrapper,
} from '@domains/new-conversation/organisms/ReportSummary/ReportSummary.styled';

export const ReportSummary = () => {
    const { caseUuid } = useParams<{ caseUuid: string }>();
    const [currentEdit, setCurrentEdit] = useState('');
    const { t } = useTranslation();

    const summarizeConversation = useCallback(
        () => summarizeResponse(caseUuid ?? ''),
        [currentEdit, caseUuid],
    );

    return (
        <SummaryWrapper>
            <SummaryTitle>{t('REPORT_CHECK_AND_EDIT')}</SummaryTitle>
            <>
                {summarizeConversation?.()?.conversationMessages.map(
                    (message, index) =>
                        message.isAssistant ? (
                            <SummaryResponseMessage
                                key={index}
                                message={message}
                                showAvatar={
                                    !summarizeConversation?.()
                                        ?.conversationMessages?.[index - 1]
                                        ?.isAssistant
                                }
                            />
                        ) : (
                            <SummaryUserResponseMessage
                                currentEdit={currentEdit}
                                key={index}
                                message={message}
                                setCurrentEdit={setCurrentEdit}
                            />
                        ),
                )}
            </>
        </SummaryWrapper>
    );
};
